module.exports = __webpack_public_path__ + "static/media/image_30.06f8e0e0.png";